export const userColumns = [
    {
      field: "Date",
      headerName: "Date",
      width: 150,
    },
    // {
    //   field: "title",
    //   headerName: "Title",
    //   width: 150,
    // },
    {
      field: "Time",
      headerName: "Time",
      width: 150,
    },
    {
      field: "date",
      headerName: "Date",
      width: 150,
    },
    {
      field: "Service_id",
      headerName: "Service_id",
      width: 150,
    },
    // {
    //   field: "branch",
    //   headerName: "Branch",
    //   width: 150,
    // },
    // {
    //   field: "demo_status",
    //   headerName: "demo_status",
    //   width: 150,
    // },
    // {
    //   field: "to",
    //   headerName: "Start Date",
    //   width: 230,
    // },
    // {
    //   field: "from",
    //   headerName: "End Date",
    //   width: 230,
    // },
  ];
  